<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      <el-breadcrumb-item>内部采购申请列表</el-breadcrumb-item>
    </el-breadcrumb>
      <el-button size="mini" plain @click="showPurchaseDialog()"
                 v-if="authorities.includes('storage.inpurchase.apply.new')">新建采购单</el-button>
      <el-date-picker
        v-model="purchaseRequest.selectDate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        size="mini"
        @change="queryPurchase"
      >
      </el-date-picker>
<!--      <el-input v-model="purchaseRequest.name" placeholder="请输入内容" size="mini" style="width: 200px;"></el-input>-->
<!--      <el-select size="mini" v-model="purchaseRequest.state" placeholder="请选择状态">-->
<!--        <el-option v-for="item in stateText"-->
<!--                   :key="item.state"-->
<!--                    :label="item.name"-->
<!--                    :value="item.state"></el-option>-->
<!--      </el-select>-->
      <el-button size="mini" @click="queryPurchase">查询</el-button>
      <br>
      <span style="font-size: 13px;color: #3a8ee6">合计申请数量：{{totalNum}} 个</span>
<!--      <span style="font-size: 13px;color: #3a8ee6">合计审批数量：{{approveNum}} 个</span>-->
      <span style="font-size: 13px;color: #3a8ee6">合计金额：{{totalMoney}} 元</span>
      <el-tabs type="border-card" @tab-click="handleClick">
        <el-tab-pane label="未审批" name="first">
          <el-table height="550px" :data="inPurchaseOrderList" fit border stripe="stripe"
                    :header-cell-style="{background:'#eff3f8', color:'#333'}"
                    :row-style="{height: '0'}"
                    :cell-style="orderStateColor">
            <el-table-column
              label="操作"
              fixed="fixed"
              align="center"
              width="100">
              <template slot-scope="scope">
                <el-link type="danger" :disabled="scope.row.state >= 2"
                         v-if="authorities.includes('storage.inpurchase.apply.cancel')"
                         icon="iconfont icon-zuofei" @click="cancelPurchase(scope.row)"></el-link>
              </template>
            </el-table-column>
            <el-table-column
              prop="purchaseDate"
              label="采购日期"
              width="150"
              align="center">
            </el-table-column>
            <el-table-column
              align="center"
              prop="state"
              :formatter="stateFormatter"
              label="状态">
            </el-table-column>
            <el-table-column
              prop="productName"
              label="产品名称"
              width="180"
              align="center">
            </el-table-column>
            <el-table-column
              prop="consumptionTypeName"
              label="产品分类"
              width="180"
              align="center">
            </el-table-column>
            <el-table-column
              prop="purchaseMoney"
              label="采购费用"
              align="center">
            </el-table-column>
            <el-table-column
              prop="applyNum"
              label="申请采购数量"
              width="120"
              align="center">
            </el-table-column>
            <el-table-column
              prop="buyerName"
              label="采购人"
              align="center">
            </el-table-column>
            <el-table-column
              prop="inOrgName"
              label="采购机构"
              width="150"
              align="center">
            </el-table-column>
            <el-table-column
              prop="approveNum"
              label="审批数量"
              align="center">
            </el-table-column>
            <el-table-column
              prop="approverName"
              label="审批人"
              width="150"
              align="center">
            </el-table-column>
            <el-table-column
              prop="outOrgName"
              label="审批机构"
              width="150"
              align="center">
            </el-table-column>
            <el-table-column
              prop="purchaseNo"
              label="采购单号"
              align="center" width="250">
            </el-table-column>
            <el-table-column
              prop="applyComment"
              label="申请时备注"
              align="center" width="250">
            </el-table-column>
          </el-table>
          <div style="margin-top: 3px;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已审批" name="second">
            <el-table height="550px" :data="approveInPurchaseOrderList" fit border stripe="stripe"
                      :header-cell-style="{background:'#eff3f8', color:'#333'}"
                      :row-style="{height: '0'}"
                      :cell-style="orderStateColor">
              <el-table-column
                label="操作"
                fixed="fixed"
                align="center"
                width="100">
                <template slot-scope="scope">
                  <el-link type="primary"  icon="iconfont icon-xiangqing"
                           @click="showOrderDetailDialog(scope.row.approveDate)"></el-link>
                </template>
              </el-table-column>
              <el-table-column
                prop="approveDate"
                label="审批日期"
                align="center">
              </el-table-column>
              <el-table-column
                prop="outOrgName"
                label="审批机构"
                align="center">
              </el-table-column>
              <el-table-column
                prop="applyNum"
                label="申请采购数量"
                width="120"
                align="center">
              </el-table-column>
              <el-table-column
                prop="purchaseMoney"
                label="采购费用"
                align="center">
              </el-table-column>
<!--              <el-table-column-->
<!--                prop="inOrgName"-->
<!--                label="采购机构"-->
<!--                width="150"-->
<!--                align="center">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="approveNum"-->
<!--                label="审批数量"-->
<!--                align="center">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="outOrgName"-->
<!--                label="审批机构"-->
<!--                width="150"-->
<!--                align="center">-->
<!--              </el-table-column>-->
            </el-table>
            <div style="margin-top: 3px;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal">
              </el-pagination>
            </div>
        </el-tab-pane>
      </el-tabs>


      <el-dialog
        title="内部采购单"
        :visible.sync="inPurchaseDialogVisible"
        width="60%"
        @close="closePurchaseDialog"
        :close-on-click-modal="false"
      >
        <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
        <el-card class="box-card">
          <div style="text-align: right">
            <el-button size="mini" plain @click="showProductDrawer">添加明细</el-button>
          </div>
          <el-table :data="selectProductList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                    height="300"
                    :row-style="{height: '0'}">
            <el-table-column
              align="center"
              prop="userName"
              label="操作" width="100">
              <template slot-scope="scope">
                <el-link type="danger" icon="el-icon-delete"
                         @click="deleteConsumptionShowList(scope.$index, selectProductList)"></el-link>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="consumptionName"
              label="产品名称">
            </el-table-column>
            <el-table-column
              align="center"
              label="数量"
            >
              <template slot-scope="scope">
                <el-input v-model="scope.row.num" size="mini" @change="getTotal"
                          onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="采购单价">
              <template slot-scope="scope">
                <!--              <div v-if="productTypeName === '自采产品'">-->
                <!--                <el-input v-if="authorities.includes('inPurchase.price.modify')" disabled v-model="scope.row.price"-->
                <!--                          size="mini" @change="getTotal" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>-->
                <!--              </div>-->
                <!--              <div v-if="productTypeName !== '自采产品'">-->
                <div v-if="(currentOrgPurchaseLevel-0) === 1">
                  <el-input disabled v-model="scope.row.oneLevelPrice"
                            size="mini" @change="getTotal" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
                </div>
                <div v-if="(currentOrgPurchaseLevel-0) === 2">
                  <el-input  disabled v-model="scope.row.twoLevelPrice"
                             size="mini" @change="getTotal" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
                </div>
                <div v-if="(currentOrgPurchaseLevel-0) === 3">
                  <el-input disabled v-model="scope.row.threeLevelPrice"
                            size="mini" @change="getTotal" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
                </div>
                <!--              </div>-->
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="小计">
              <template slot-scope="scope">
                <!--              <div v-if="productTypeName === '自采产品'">-->
                <!--                {{ (scope.row.price * scope.row.num).toFixed(1)}}-->
                <!--              </div>-->
                <!--              <div v-if="productTypeName !== '自采产品'">-->
                <div v-if="(currentOrgPurchaseLevel-0) === 1">
                  {{ (scope.row.oneLevelPrice * scope.row.num).toFixed(1)}}
                </div>
                <div v-if="(currentOrgPurchaseLevel-0) === 2">
                  {{ (scope.row.twoLevelPrice * scope.row.num).toFixed(1)}}
                </div>
                <div v-if="(currentOrgPurchaseLevel-0) === 3">
                  {{ (scope.row.threeLevelPrice * scope.row.num).toFixed(1)}}
                </div>
                <!--              </div>-->
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card class="box-card">
          <div>
            <span >采购金额： </span>
            <el-input style="width: 300px" disabled v-model="purchase.purchaseMoney" size="mini" />
          </div>
        </el-card>
        <el-card class="box-card">
          <div>
            <span >备注说明： </span>
            <el-input style="width: 100%" placeholder="请输入内容" v-model="purchase.comment" type="textarea" />
          </div>
        </el-card>
        <span class="dialog-footer">
        <el-button size="mini" @click="closePurchaseDialog">取 消</el-button>
        <el-button size="mini" @click="createPurchase">确 定</el-button>
      </span>
      </el-dialog>

      <el-drawer
        title="产品列表"
        size="60%"
        :visible.sync="productDrawerVisible"
        :before-close="closeProductDrawer"
      >
        <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
        <div class="between" style="padding: 0 10px">
          <div class="left_con" >
            <div class="left_inner_con">
<!--              <el-input size="mini"-->
<!--                        style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"-->
<!--                        placeholder="输入关键字进行过滤"-->
<!--                        v-model="consumptionTypeFilterText">-->
<!--              </el-input>-->
              <el-card class="box-card">
                <el-tree
                  :data="consumptionTypeList"
                  :props="consumptionTypeProps"
                  @node-click="consumptionTypeHandleNodeClick"
                  :highlight-current="true"
                  node-key="id"
                  :filter-node-method="consumptionTypeFilterNode"
                  default-expand-all
                  ref="serviceTree"
                >
                </el-tree>
              </el-card>
            </div>
          </div>
          <div class="table_container" style="margin: 10px 0">
<!--            <el-input size="mini"-->
<!--                      style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"-->
<!--                      placeholder="输入关键字进行过滤"-->
<!--                      v-model="consumptionQueryText"-->
<!--                      @keyup.enter.native="queryConsumption"-->
<!--            >-->
<!--            </el-input>-->
            <el-card class="box-card">
              <el-table height="600px" :data="consumptionList" fit border stripe="stripe"
                        :header-cell-style="{background:'#eff3f8', color:'#333'}"
                        :row-style="{height: '0'}">
                <el-table-column
                  align="center"
                  prop="userName"
                  fixed="fixed"
                  label="操作" width="160">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.num"
                                     size="mini"
                                     @change="orderNumHandleChange(scope.row)" :min="0" :max="99999999" label="描述文字"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="consumptionName"
                  fixed="fixed"
                  label="产品名称">
                </el-table-column>
                <el-table-column
                  align="center"
                  label="采购价格">
                  <template slot-scope="scope">
                    <div v-if="productTypeName === '自采产品'">
                      {{scope.row.price}}
                    </div>
                    <div v-if="(currentOrgPurchaseLevel-0) === 1">
                      {{scope.row.oneLevelPrice}}
                    </div>
                    <div v-if="(currentOrgPurchaseLevel-0) === 2">
                      {{scope.row.twoLevelPrice}}
                    </div>
                    <div v-if="(currentOrgPurchaseLevel-0) === 3">
                      {{scope.row.threeLevelPrice}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="practicalNum"
                  label="实际库存">
                </el-table-column>
              </el-table>
              <div style="margin-top: 3px;">
                <el-pagination
                  @size-change="handleSizeChange1"
                  @current-change="handleCurrentChange1"
                  :current-page="currentPage1"
                  :page-sizes="[10, 20, 30, 50]"
                  :page-size="pageSize1"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="pageTotal1">
                </el-pagination>
              </div>
            </el-card>
          </div>
        </div>
      </el-drawer>

    <el-dialog
      title="申请单详情"
      :visible.sync="orderDetailDialogVisible"
      width="60%"
      @close="closeOrderDetailDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table height="300px" :data="details" fit border stripe="stripe"
                :header-cell-style="{background:'#eff3f8', color:'#333'}">
        <el-table-column
          prop="productName"
          label="产品名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="productPrice"
          label="产品单价"
          align="center">
        </el-table-column>
        <el-table-column
          prop="applyNum"
          label="申请数量"
          align="center">
        </el-table-column>
        <el-table-column
          prop="approveNum"
          label="审批数量"
          align="center">
        </el-table-column>
        <el-table-column
          label="产品费用"
          align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.approveNum > 0">
              {{scope.row.purchaseMoney}}
            </div>
            <div v-if="scope.row.approveNum == 0">
              0
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-card>
        <el-input type="textarea" v-model="comment"></el-input>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      currentOrgId:'',
      currentOrgLevel:'',
      authorities:'',
      userId:'',
      currentOrgPurchaseLevel:'',
      inPurchaseOrderList:[],
      approveInPurchaseOrderList:[],
      selectProductList:[],
      inPurchaseDialogVisible:false,
      purchase:{
        id:'',
        purchaseDate:'',
        productNo:'',
        purchaseNo:'',
        purchaseMoney:'',
        buyer:'',
        approver:'',
        inOrgId:'',
        outOrgId:'',
        orgName:'',
        creator:'',
        buyerName:'',
        consumptions:[],
        outsidePurchaseDetails:[],
        orgPurchaseLevel:'',
        productTypeName:'',
        comment:''
      },
      productDrawerVisible:false,
      purchaseDetailDialogVisible:false,
      consumptionTypeList:[],
      consumptionTypeFilterText:'',
      consumptionTypeProps:{
        label: 'consumptionTypeName',
        children: 'children'
      },
      consumptionList:[],
      stateText:[
        {state:1, name:'提起申请'},
        {state:2, name:'已作废'},
        {state:3, name:'审批中'},
        {state:4, name:'审批通过'},
        {state:5, name:'审批驳回'},
        {state:6, name:'审批完成'},
      ],

      //查询部分的参数
      consumptionQueryText:'',
      consumptionTypeId:'',
      //获取申请采购单的OrgId
      inOrgId:'',
      currentPage: 1,
      pageSize:100,
      pageTotal:0,

      currentPage1: 1,
      pageSize1:20,
      pageTotal1:0,

      //产品分类
      productTypeName:'',
      purchaseRequest:{
        selectDate:'',
        orgId:'',
        pageNum:'',
        pageSize:'',
        startDate:'',
        endDate:'',
        name:'',
        state:'',
        type:''
      },
      consumptionRequest:{
        orgId:'',
        typeId:'',
        dateType:'',
        pageNum:'',
        pageSize:'',
        queryText:'',
        productTypeId:'',
        consumptionId:''
      },
      totalMoney:'',
      totalNum:'',
      createPurchaseDoubleClick:false,
      details:[],
      orderDetailDialogVisible:false,
      comment:'',
      paneName:''
    }
  },
  methods:{
    handleClick(tab, event){
      this.paneName = tab.paneName;
      this.purchaseRequest.type = tab.paneName;
      if (tab.paneName == 'first'){
        this.loadPurchaseListApply();
      }
      if (tab.paneName == 'second'){
        this.loadSpgInPurList();
      }
    },
    showOrderDetailDialog(approveDate){
      this.loadSendListByNo(approveDate);
      this.orderDetailDialogVisible = true;
    },
    closeOrderDetailDialog(){
      this.orderDetailDialogVisible = false;
    },
    queryPurchase(){
      if (this.paneName == 'first'){
        this.loadPurchaseListApply();
      }
      if (this.paneName == 'second'){
        this.loadSpgInPurList();
      }
      // this.loadInPurchaseList();
      // this.loadInPurchaseCount();
    },
    async loadInPurchaseCount(){
      this.totalMoney = '';
      this.totalNum = '';
      this.purchaseRequest.startDate = '';
      this.purchaseRequest.endDate = '';
      if (this.purchaseRequest.selectDate !== null){
        this.purchaseRequest.startDate = this.purchaseRequest.selectDate[0];
        this.purchaseRequest.endDate = this.purchaseRequest.selectDate[1];
      }
      this.purchaseRequest.pageNum = this.currentPage;
      this.purchaseRequest.pageSize = this.pageSize;
      this.purchaseRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/inPurchase/query/apply/count`, this.purchaseRequest)
      this.pageTotal = res.totalPage;
    },

    async loadInPurchaseList(){
      this.totalMoney = '';
      this.totalNum = '';
      this.purchaseRequest.startDate = '';
      this.purchaseRequest.endDate = '';
      if (this.purchaseRequest.selectDate !== null){
        this.purchaseRequest.startDate = this.purchaseRequest.selectDate[0];
        this.purchaseRequest.endDate = this.purchaseRequest.selectDate[1];
      }
      this.purchaseRequest.pageNum = this.currentPage;
      this.purchaseRequest.pageSize = this.pageSize;
      this.purchaseRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/inPurchase/query/apply`, this.purchaseRequest)
      this.inPurchaseOrderList = res.data;

      this.purchaseRequest.state = 4;
      const {data:res1} = await this.$http.post(`/inPurchase/query/apply/total`, this.purchaseRequest)
      if (res1.data !== null){
        this.totalNum = res1.data.totalNum;
        this.totalMoney = res1.data.totalMoney;
      }
    },
    //显示新建采购单窗口
    async showPurchaseDialog(){
      this.purchase.productNo = '';
      this.purchase.purchaseMoney = '';
      this.purchase.comment = '';
      this.selectProductList = [];
      this.inPurchaseDialogVisible = true;
    },
    //关闭采购单窗口
    closePurchaseDialog(){
      this.inPurchaseDialogVisible = false;
    },
    //采购单产品列表方法
    deleteConsumptionShowList(index,rows){
      rows.splice(index, 1);
      this.getTotal();
    },
    //加载申请列表
    loadPurchaseListApply(){
      this.loadInPurchaseCount();
      this.loadInPurchaseList();
    },
    //状态方法
    stateFormatter(row){
      let value = "";
      for (let i = 0; i < this.stateText.length; i++){
        let item = this.stateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    //状态显示颜色方法
    orderStateColor({row,columnIndex}){
      if (row.state === 1 && columnIndex ===2){
        return 'color:#3385ff';
      } else if (row.state === 2 && columnIndex ===2){
        return 'color:#EA1B28';
      } else if (row.state === 3 && columnIndex ===2){
        return 'color:#ffa64d';
      } else if (row.state === 4 && columnIndex ===2){
        return 'color:#0CB618';
      } else if (row.state === 5 && columnIndex ===2){
        return 'color:#a64dff';
      } else if (row.state === 6 && columnIndex ===2){
        return 'color:#8585ad';
      }
    },
    //作废采购单的方法
    async cancelPurchase(row){
      const {data:res} = await this.$http.get(`/insidePurchase/cancel/${row.id}`);
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
      this.loadPurchaseListApply();
    },
    //显示产品列表的方法
    showProductDrawer(){
      this.loadProductTypeList();
      this.productDrawerVisible = true;
    },
    //关闭产品列表的方法
    closeProductDrawer(){
      this.getTotal();
      this.productDrawerVisible = false;
    },
    getTotal(){
      let purchaseMoney = 0;
      for (let i = 0; i < this.selectProductList.length; i++) {
        // if (this.productTypeName === '自采产品'){
        //   purchaseMoney += this.selectProductList[i].price * this.selectProductList[i].num;
        // } else {
          if((this.currentOrgPurchaseLevel-0) === 1){
            purchaseMoney += this.selectProductList[i].oneLevelPrice * this.selectProductList[i].num;
          }
          if((this.currentOrgPurchaseLevel-0) === 2){
            purchaseMoney += this.selectProductList[i].twoLevelPrice * this.selectProductList[i].num;
          }
          if ((this.currentOrgPurchaseLevel-0) === 3){
            purchaseMoney += this.selectProductList[i].threeLevelPrice * this.selectProductList[i].num;
          }
        // }
      }
      this.purchase.purchaseMoney = purchaseMoney;
    },
    //加载产品分类的方法
    async loadProductTypeList(){
      this.consumptionList = [];
      const {data:res} = await this.$http.get(`/consumptionType/purchase/orgId/${this.currentOrgId}`)
      this.consumptionTypeList = res.data;
    },
    //创建采购单的方法
    async createPurchase(){
      this.purchase.buyer = this.userId;
      this.purchase.inOrgId = this.currentOrgId;
      this.purchase.consumptions = this.selectProductList;
      this.purchase.orgPurchaseLevel = this.currentOrgPurchaseLevel;
      this.purchase.productTypeName = this.productTypeName;
      this.purchase.creator = this.userId;
      if (this.selectProductList.length === 0){
        return this.$message.warning("请选择产品！");
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      //operateType 1表示新增  2.表示审批 3.表示编辑
      const {data:res} = await this.$http.post(`/insidePurchase`, this.purchase);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      await this.loadPurchaseListApply();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.closePurchaseDialog();
    },

    //选择产品的方法
    orderNumHandleChange(value){
      this.isSelect = 2;
      let result = true;
      for (let i = 0; i < this.selectProductList.length; i++) {
        if (this.selectProductList[i].productId === value.productId && value.num > 0){
          this.selectProductList[i].num = value.num;
          result = false;
        }

        if (this.selectProductList[i].productId === value.productId && value.num === 0){
          this.selectProductList.splice(i,1);
          result = false;
        }
      }
      if (result){
        this.selectProductList.push(value);
      }
    },

    //选中产品分类加载产品的方法
    async consumptionTypeHandleNodeClick(data){
      this.consumptionTypeId = data.consumptionTypeId;
      this.type = data.type;
      this.productTypeName = data.consumptionTypeName;
      await this.queryConsumption();
    },
    //关键字查询产品的方法
    async queryConsumption(){

      // const {data:res} = await this.$http.get(`/consumption/apply/type/${this.type}/typeId/${this.consumptionTypeId}/orgId/${this.currentOrgId}/queryConsumption/${text}/pageNum/${this.currentPage1}/pageSize/${this.pageSize1}`)
      // this.consumptionList = res.data.list;
      // this.pageTotal1 = res.data.total;
      await this.loadConsumptionTotal();
      await this.loadConsumptionList();
    },
    async loadConsumptionTotal(){
      let text = 'null';
      if (this.consumptionQueryText !== ''){
        text = this.consumptionQueryText;
      }
      // this.consumptionRequest.dateType = this.type;
      this.consumptionRequest.productTypeId = this.consumptionTypeId;
      this.consumptionRequest.pageNum = this.currentPage1;
      this.consumptionRequest.pageSize = this.pageSize1;
      this.consumptionRequest.orgId = this.currentOrgId;
      this.consumptionRequest.queryText = 'null';
      // const {data:res} = await this.$http.post(`/consumption/apply/type/${this.type}/typeId/${this.consumptionTypeId}/orgId/${this.currentOrgId}/queryConsumption/${text}/pageNum/${this.currentPage1}/pageSize/${this.pageSize1}`)
      const {data:res} = await this.$http.post(`/load/count/consumption/apply`, this.consumptionRequest)
      this.pageTotal1 = res.totalPage;
    },
    async loadConsumptionList(){
      let text = 'null';
      if (this.consumptionQueryText !== ''){
        text = this.consumptionQueryText;
      }
      this.consumptionRequest.productTypeId = this.consumptionTypeId;
      this.consumptionRequest.pageNum = this.currentPage1;
      this.consumptionRequest.pageSize = this.pageSize1;
      this.consumptionRequest.orgId = this.currentOrgId;
      this.consumptionRequest.queryText = 'null';
      // const {data:res} = await this.$http.post(`/consumption/apply/type/${this.type}/typeId/${this.consumptionTypeId}/orgId/${this.currentOrgId}/queryConsumption/${text}/pageNum/${this.currentPage1}/pageSize/${this.pageSize1}`)
      const {data:res} = await this.$http.post(`/load/list/consumption/apply`, this.consumptionRequest)
      this.consumptionList = res.data;
    },
    consumptionTypeFilterNode(value, data) {
      if (!value) return true;
      return data.consumptionTypeName.indexOf(value) !== -1;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadPurchaseListApply();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadPurchaseListApply();
    },

    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.loadConsumptionList();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.loadConsumptionList();
    },
    //计算table高度(动态设置table高度)
    getTableHeight() {
      let tableH = 295; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 300) {
        this.tableHeight = 300;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },
    //加载发送列表
    async loadSpgInPurList(){
      this.purchaseRequest.startDate = '';
      this.purchaseRequest.endDate = '';
      if (this.purchaseRequest.selectDate !== null){
        this.purchaseRequest.startDate = this.purchaseRequest.selectDate[0];
        this.purchaseRequest.endDate = this.purchaseRequest.selectDate[1];
      }
      this.purchaseRequest.pageNum = this.currentPage;
      this.purchaseRequest.pageSize = this.pageSize;
      this.purchaseRequest.inOrgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/spg/inPur/query`, this.purchaseRequest);
      if (res.code === 200){
        this.approveInPurchaseOrderList = res.data.list;
        // this.comment = this.details[0].comment;
      }

      this.purchaseRequest.state = 3;
      const {data:res1} = await this.$http.post(`/inPurchase/query/apply/total`, this.purchaseRequest)
      if (res1.data !== null){
        this.totalNum = res1.data.approveNum;
        this.totalMoney = res1.data.totalMoney;
      }
    },
    //加载发送列表
    async loadSendListByNo(approveDate){
      this.purchaseRequest.startDate = '';
      this.purchaseRequest.endDate = '';
      if (this.purchaseRequest.selectDate !== null){
        this.purchaseRequest.startDate = this.purchaseRequest.selectDate[0];
        this.purchaseRequest.endDate = this.purchaseRequest.selectDate[1];
      }
      this.purchaseRequest.pageNum = this.currentPage;
      this.purchaseRequest.pageSize = this.pageSize;
      this.purchaseRequest.inOrgId = this.currentOrgId;
      this.purchaseRequest.approveDate = approveDate;
      const {data:res} = await this.$http.post(`/query/inPur/approve/date`, this.purchaseRequest);
      if (res.code === 200){
        this.details = res.data.list;
        this.details.map((item)=>{
          if (item.approveComment != null){
            this.comment = this.comment + item.approveComment + ",";
          }
        })
      }
    },
  },
  watch: {
    consumptionTypeFilterText(val) {
      this.$refs.serviceTree.filter(val);
    }
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.currentOrgPurchaseLevel = window.sessionStorage.getItem("currentOrgPurchaseLevel");
    this.currentOrgLevel = window.sessionStorage.getItem("orgLevel");
    this.authorities = window.sessionStorage.getItem('authorities');
    // this.loadPurchaseListApply();
    // this.loadSpgInPurList();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 90%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}
/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}
/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/InPurchaseApply.vue